<template>
  <App>
    <form class="form fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate" enctype="multipart/form-data" @submit.prevent="submit">
      <form-body :loading="form.processing || loading" :form="form" :hideSubmitButton="hideSubmit">
        <div class="row mb-3">
          <div class="col-3">
            <form-group label="Pôster" :is-invalid="form.errors.InscricaoBanner" v-if="!form.InscricaoBannerData || reenviaPoster">
              <input
                class="form-control"
                @input="form.InscricaoBanner = $event.target.files[0]"
                type="file"
                placeholder="Pôster"
                accept=".csv,.doc,.docx,.ppt,.pptx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf"
                @blur="form.clearErrors('InscricaoBanner')"
                :class="{'is-invalid' : form.errors.InscricaoBanner}"
              />
            </form-group>
            <div v-else class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
              <div class="d-flex align-items-center">
                <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                  <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <rect xmlns="http://www.w3.org/2000/svg" opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor"></rect>
                    <path xmlns="http://www.w3.org/2000/svg" d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor"></path>
                  </svg>
                </span>
                <div class="fs-2 fw-bold"> Pôster enviado</div>
              </div>
              <div class="fw-semobold fs-6 text-gray-400" v-if="configReenviarPoster">Clique <a href="#" @click="reenviaPoster = true">aqui</a> para reenviar.</div>
              <div class="fw-semobold fs-6 text-gray-400" v-else>Não é possível reenviar</div>
            </div>
          </div>

          <div class="col-3">
            <form-group label="Resumo" :is-invalid="form.errors.InscricaoResumo" v-if="!form.InscricaoResumoData || reenviaResumo">
              <input
                class="form-control"
                @input="form.InscricaoResumo = $event.target.files[0]"
                type="file"
                placeholder="Resumo"
                accept=".doc,.docx,application/msword,application/vnd.ms-excel"
                @blur="form.clearErrors('InscricaoResumo')"
                :class="{'is-invalid' : form.errors.InscricaoResumo}"
              />
              <span class="text-muted">Envie arquivos doc ou docx.</span>
            </form-group>
            <div v-else class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
              <div class="d-flex align-items-center">
                <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                  <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <rect xmlns="http://www.w3.org/2000/svg" opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor"></rect>
                    <path xmlns="http://www.w3.org/2000/svg" d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor"></path>
                  </svg>
                </span>
                <div class="fs-2 fw-bold"> Resumo enviado</div>
              </div>

              <div v-if="can('ADM')">
                <div class="fw-semobold fs-6 text-gray-400">
                  Clique <a href="#" @click="reenviaResumo = true">aqui</a> para reenviar.
                  <p class="fs-7 text-danger">Recurso disponível apenas para administradores.</p>
                </div>
              </div>
              <div v-else>
                <div class="fw-semobold fs-6 text-gray-400" v-if="!this.projeto.situacao_avaliacao_resumo">Seu Resumo já foi avaliado, por isso não é possível reenviar.</div>
                <div class="fw-semobold fs-6 text-gray-400" v-else>Clique <a href="#" @click="reenviaResumo = true">aqui</a> para reenviar.</div>
              </div>
            </div>
          </div>
        </div>
      </form-body>
    </form>
  </App>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import App from "@layout/App";
import FormBody from "@forms/FormBody";
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import {error, success} from "../../Settings/toastr";

export default {
  props: ['projeto'],
  components: {
    App,
    FormBody,
    SubmitButton,
    FormGroup
  },
  data: _ => ({
    loading: false,
    configReenviarPoster: false,
    reenviaPoster: false,
    configReenviarResumo: false,
    reenviaResumo: false,
    hideSubmit: false
  }),

  setup(props) {
    const form = useForm({...props.projeto});

    return {
      form
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Envia Documentos');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Projetos', link: 'app.projetos.index'},
        {title: 'Envia Documentos'},
      ]);

      this.emitter.emit('action', {
          show: true,
          icon: 'bi-arrow-left-short',
          title: 'Voltar',
          link: this.route('app.projetos.index')
        }
      );

      this.configReenviarPoster = this.$page.props.configs.reenvio_poster
      this.configReenviarResumo = this.$page.props.configs.reenvio_resumo && this.projeto.situacao_avaliacao_resumo
    },

    submit() {
      this.form.post(this.route('app.projetos.envia-documentos', this.form.id), {
        onError: error,
        onSuccess: () => {
          success(this.$page.props.success);
          this.hideSubmit = true
          setTimeout( () => {
            window.location.reload()
          }, 2000)
        }
      });
    },
  }
}

</script>
